import {BaseAnalyticsEvent} from "./base-analytics-event";

export class ClickEvent extends BaseAnalyticsEvent {

  constructor(value, label = 'click', action = '', category = 'web') {
    super(value, label, action, category);
  }
}
